import { CourseWithChapters } from "@jelly/lesson";
import { courseAndChapterMessages } from "@src/lms/data/course/messages";
import { messages } from "@src/lms/data/lesson/course-01/messages";
import { IntlShape } from "react-intl";

export const availableChapters = (intl: IntlShape): CourseWithChapters["chapters"] => {
  return [
    {
      id: "c770f0b3-36e6-4cf0-8e4d-3c9696b072f5",
      publicId: "1",
      name: intl.formatMessage(courseAndChapterMessages.C1_CH1_Name),
      description: intl.formatMessage(courseAndChapterMessages.C1_CH1_Description),
      position: 0,
      chapterLessons: [
        {
          lesson: {
            id: "f239b7a0-7087-41f4-9718-bdaf99dbada5",
            publicId: "1",
            name: intl.formatMessage(messages.C1_CH1_L1_Name),
            body: [],
          },
          position: 1,
        },
        {
          lesson: {
            id: "08186a9f-636e-474d-9a09-0cd901495a63",
            publicId: "2",
            name: intl.formatMessage(messages.C1_CH1_L2_Name),
            body: [],
          },
          position: 1,
        },
        {
          lesson: {
            id: "c1ce9570-3b52-4b92-a5e7-74ad752f297d",
            publicId: "3",
            name: intl.formatMessage(messages.C1_CH1_L3_Name),
            body: [],
          },
          position: 2,
        },
        {
          lesson: {
            id: "11077099-dcca-4b8a-ba1f-0801662b2686",
            publicId: "4",
            name: intl.formatMessage(messages.C1_CH1_L4_Name),
            body: [],
          },
          position: 3,
        },
        {
          lesson: {
            id: "2436bc98-de27-4481-8416-a6b3c96b4e1e",
            publicId: "5",
            name: intl.formatMessage(messages.C1_CH1_L5_Name),
            body: [],
          },
          position: 4,
        },
        {
          lesson: {
            id: "03b7315e-440f-4055-b2da-0c30ceceb4ee",
            publicId: "6",
            name: intl.formatMessage(messages.C1_CH1_L6_Name),
            body: [],
          },
          position: 5,
        },
      ],
    },
    {
      id: "ddda6aa1-3531-4f82-b5fd-5845b7948033",
      publicId: "2",
      name: intl.formatMessage(courseAndChapterMessages.C1_CH2_Name),
      description: intl.formatMessage(courseAndChapterMessages.C1_CH2_Description),
      position: 2,
      chapterLessons: [
        {
          lesson: {
            id: "3de9642d-fa92-49fb-ba2b-d167ee178507",
            publicId: "1",
            name: intl.formatMessage(messages.C1_CH2_L1_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "c6bd5391-5c2d-4ca2-aa80-781de1259484",
            publicId: "2",
            name: intl.formatMessage(messages.C1_CH2_L2_Name),
            body: [],
          },
          position: 8,
        },
        {
          lesson: {
            id: "99d61283-162e-4743-98b5-f6b573e0fcf5",
            publicId: "3",
            name: intl.formatMessage(messages.C1_CH2_L3_Name),
            body: [],
          },
          position: 9,
        },
        {
          lesson: {
            id: "ebd48d48-4a25-4f24-9dbd-7e386bf47346",
            publicId: "4",
            name: intl.formatMessage(messages.C1_CH2_L4_Name),
            body: [],
          },
          position: 10,
        },
        {
          lesson: {
            id: "3667c9b5-4d43-4144-96f8-38a36b684f2c",
            publicId: "5",
            name: intl.formatMessage(messages.C1_CH2_L5_Name),
            body: [],
          },
          position: 11,
        },
      ],
    },
    {
      id: "0da77274-799a-4dde-9305-4c78d020103b",
      publicId: "3",
      name: intl.formatMessage(courseAndChapterMessages.C1_CH3_Name),
      description: intl.formatMessage(courseAndChapterMessages.C1_CH3_Description),
      position: 3,
      chapterLessons: [
        {
          lesson: {
            id: "67c2ebd6-3b90-4f12-9190-bc5b8b030a18",
            publicId: "1",
            name: intl.formatMessage(messages.C1_CH3_L1_Name),
            body: [],
          },
          position: 12,
        },
        {
          lesson: {
            id: "5f33c30e-8c05-48ae-a10e-adfed88bcd54",
            publicId: "2",
            name: intl.formatMessage(messages.C1_CH3_L2_Name),
            body: [],
          },
          position: 13,
        },
      ],
    },
    {
      id: "4",
      publicId: "4",
      name: intl.formatMessage(courseAndChapterMessages.C1_CH4_Name),
      description: intl.formatMessage(courseAndChapterMessages.C1_CH4_Description),
      position: 4,
      chapterLessons: [
        {
          lesson: {
            id: "5a2d5937-98af-4d8f-9b5f-c2e8dea6e978",
            publicId: "1",
            name: intl.formatMessage(messages.C1_CH4_L1_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "182c279d-619a-40c0-ab74-50ed46e66e86",
            publicId: "2",
            name: intl.formatMessage(messages.C1_CH4_L2_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "360146db-222a-4170-9538-d7448897af52",
            publicId: "3",
            name: intl.formatMessage(messages.C1_CH4_L3_Name),
            body: [],
          },
          position: 7,
        },
      ],
    },
    {
      id: "5",
      publicId: "5",
      name: intl.formatMessage(courseAndChapterMessages.C1_CH5_Name),
      description: intl.formatMessage(courseAndChapterMessages.C1_CH5_Description),
      position: 0,
      chapterLessons: [
        {
          lesson: {
            id: "67ed3804-5dec-4c72-a08e-1de00f0c4e59",
            publicId: "1",
            name: intl.formatMessage(messages.C1_CH5_L1_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "7a640173-9283-4047-8ef3-75863925c04b",
            publicId: "2",
            name: intl.formatMessage(messages.C1_CH5_L2_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "a9180d4d-d5c6-483c-89f1-65f0b3d36d2c",
            publicId: "3",
            name: intl.formatMessage(messages.C1_CH5_L3_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "a9b68924-4db5-4524-a730-f749e6103920",
            publicId: "4",
            name: intl.formatMessage(messages.C1_CH5_L4_Name),
            body: [],
          },
          position: 7,
        },
      ],
    },
    {
      id: "6",
      publicId: "6",
      name: intl.formatMessage(courseAndChapterMessages.C1_CH6_Name),
      description: intl.formatMessage(courseAndChapterMessages.C1_CH6_Description),
      position: 0,
      chapterLessons: [
        {
          lesson: {
            id: "9d9378cc-3e79-4f35-be25-e33535a266e0",
            publicId: "1",
            name: intl.formatMessage(messages.C1_CH6_L1_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "dbc8f918-ff90-427c-b54f-97e669f4b31d",
            publicId: "2",
            name: intl.formatMessage(messages.C1_CH6_L2_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "e56a1924-5521-417e-86a2-13cfb702af78",
            publicId: "3",
            name: intl.formatMessage(messages.C1_CH6_L3_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "c743a519-984d-45c2-bb38-56d8af323fbf",
            publicId: "4",
            name: intl.formatMessage(messages.C1_CH6_L4_Name),
            body: [],
          },
          position: 7,
        },
      ],
    },
    {
      id: "7",
      publicId: "7",
      name: intl.formatMessage(courseAndChapterMessages.C1_CH7_Name),
      description: intl.formatMessage(courseAndChapterMessages.C1_CH7_Description),
      position: 0,
      chapterLessons: [
        {
          lesson: {
            id: "7d58668c-df01-4246-b59e-96fc7e22405b",
            publicId: "1",
            name: intl.formatMessage(messages.C1_CH7_L1_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "6a57ef2e-8555-49fb-a4ec-eecbbf09ee87",
            publicId: "2",
            name: intl.formatMessage(messages.C1_CH7_L2_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "a459156b-f39d-4377-8d34-16309c100fca",
            publicId: "3",
            name: intl.formatMessage(messages.C1_CH7_L3_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "2b22e9b4-95ad-4a1a-86c1-f018e7c503c9",
            publicId: "4",
            name: intl.formatMessage(messages.C1_CH7_L4_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "631a5802-567d-4472-8984-210ed1a0f308",
            publicId: "5",
            name: intl.formatMessage(messages.C1_CH7_L5_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "1260eaa3-8a7a-484b-bed8-9235ec026cbd",
            publicId: "6",
            name: intl.formatMessage(messages.C1_CH7_L6_Name),
            body: [],
          },
          position: 7,
        },
        {
          lesson: {
            id: "5ba6e6f7-3909-4f65-bb84-6e90c5d00a4b",
            publicId: "7",
            name: intl.formatMessage(messages.C1_CH7_L7_Name),
            body: [],
          },
          position: 7,
        },
      ],
    },
  ];
};
